import { render, staticRenderFns } from "./tianmap.vue?vue&type=template&id=2c5f7d52&scoped=true"
import script from "./tianmap.vue?vue&type=script&lang=js"
export * from "./tianmap.vue?vue&type=script&lang=js"
import style0 from "./tianmap.vue?vue&type=style&index=0&id=2c5f7d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5f7d52",
  null
  
)

export default component.exports